<template>
  <div>
    <landscape-warning v-show="showLandscapeWarning" />
    <div class="onboarding--container" v-show="!showLandscapeWarning">
      <div class="onboarding--header">
        <div class="prclx-logo">
          <asset-v3
            dir="logos"
            name="logo.svg"
          />
        </div>

        <step-progress-bar
          class="step--bar"
          stepTitle="confirmação de identidade"
          :stepNumber="4"
          :stepSize="4"
        />
      </div>

      <div class="onboarding--content">
        <slot name="content"></slot>
      </div>

      <div class="onboarding--footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AssetV3 from '@/components/common/AssetV3.vue';
import UtilMixin from '@/mixins/util';
import StepProgressBar from '../../paymentLink/components/StepProgressBar.vue';
import LandscapeWarning from './LandscapeWarning.vue';

export default {
  name: 'v2-onboarding-identity-step-layout',
  components: {
    AssetV3,
    StepProgressBar,
    LandscapeWarning,
  },
  mixins: [UtilMixin],
  data: () => ({
    landscape: false,
  }),
  computed: {
    ...mapState('onboardingV2', ['showLandscapeWarning']),
  },
};
</script>

<style lang="scss" style="scoped">
  @import '../../../scss/__new-styles.scss';

  .onboarding--container {
    padding: 0px 24px 0 24px;
    display: grid;
    grid-template-rows: 150px 3fr 100px;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }

  .onboarding--header {
    .prclx-logo {
      display: flex;
      padding-top: 16px;
      justify-content: center;
    }

    .step--bar {
      padding-top: 24px;
    }
  }
</style>
